class ViewColoursPanel extends window.SlideOutPanel {
  get openTriggerSelector() {
    return '[data-view-colours]';
  }

  onConnected() {
    this.list = this.querySelector('#view-colours-panel-list') || document.getElementById('view-colours-panel-list');
  }

  onBeforeOpen() {
    this.markSelected();
  }

  populate(itemsContainer) {
    if (!this.list || !itemsContainer) return;

    const nodes = Array.from(itemsContainer.children).map((child) => document.importNode(child, true));
    this.list.replaceChildren(...nodes);
    this.markSelected();
  }

  markSelected() {
    const swatchesContainer = document.getElementById('swatches-container');
    if (!swatchesContainer || !this.list) return;

    const currentSwatch = (swatchesContainer.dataset.productSwatch || '')
      .toLowerCase()
      .replaceAll(' /', '')
      .replaceAll(' ', '-');

    this.list.querySelectorAll('.view-colours-panel__item').forEach((item) => {
      item.classList.toggle('is-selected', item.dataset.productSwatch === currentSwatch);
    });
  }
}

if (!customElements.get('view-colours-panel')) {
  customElements.define('view-colours-panel', ViewColoursPanel);
}
